import type { ActiveGameData } from '@ps/web-poker-types';
import React from 'react';

import GameItem from './GameItem';
import styles from './GamesList.scss';

interface Props {
  games: ActiveGameData[];
  onAction?: (game: ActiveGameData) => void;
}

const GamesList: React.FC<Props> = ({ games, onAction }) => (
  <div className={styles.gamesList}>
    {games.map((game) => (
      <GameItem key={game.id} game={game} onAction={onAction} />
    ))}
  </div>
);

export default GamesList;
